export default "__VITE_ASSET__44c7bfe1__"